import { Fragment, h } from 'preact';
import { playerStatic } from '../../../../../../../configuration';
import { preloadImage } from '../../../../../../../utils/preloadImage';

export const animationLogoUrls = [
  '2', '3', '4', '5', 'info'
]
  .map((key) => `${playerStatic.url}/logo/nude/france${key}.svg`);

animationLogoUrls.forEach((logo) => preloadImage(logo));

export default function ZapetteFullscreenChannels({
  size
}) {
  return (
    <Fragment>
      <div className="animation-separator" />
      {animationLogoUrls.map((logo, index) => (
        <div
          className="animation-logo"
          style={{ animationDelay: `${index / 20}s`, maxHeight: size }}
        >
          <img
            alt="logo-channel"
            width={size}
            height={size}
            src={logo}
          />
        </div>
      ))}
    </Fragment>
  );
}
